import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=50e973e4&scoped=true&"
import script from "./FeaturedProducts.vue?vue&type=script&lang=ts&"
export * from "./FeaturedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=50e973e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e973e4",
  null
  
)

export default component.exports